import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { requestPut } from 'src/legacy_modules/server/request'
import type { components } from 'src/lib/api-client/schema.gen'

type LoginMethod = components['schemas']['user.LoginMethod']

type AuthenticateResponse = {
  email: string
  required_password_change: boolean
  login_method: LoginMethod
}

type Authenticated = {
  email: string
  requiredPasswordChange: boolean
  loginMethod: LoginMethod
}

export const submitAuthenticate = async ({
  trialUid,
  members,
  memberUid,
  token,
}: {
  trialUid: string
  members: string
  memberUid: string
  token: string
}): Promise<Authenticated> => {
  if (IS_MOCK_MODE) {
    return { email: '', requiredPasswordChange: false, loginMethod: 'Password' }
  }

  const resp = await requestPut<AuthenticateResponse>({
    url: `${SERVER_URL}/trials/${trialUid}/${members}/${memberUid}/${token}`,
    params: {},
  })

  return {
    email: resp.data.email,
    requiredPasswordChange: resp.data.required_password_change,
    loginMethod: resp.data.login_method,
  }
}
